import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { Storage } from "@ionic/storage";
import { User } from "../models/user";
import { AuthenticateService } from "./authentication/authenticate.service";

@Injectable({
  providedIn: "root",
})
export class BaseService {
  constructor(public httpClient: HttpClient, public storage: Storage) {}
  tags = ["script", "iframe", "img", "html"];
  get(url: string): Observable<any> {
    return this.httpClient.get(url).pipe(
      tap((res) => {}),
      catchError((e) => {
        this.processError(e);
        throw e;
      })
    );
  }

  getWithHeader(url: string, headers: HttpHeaders): Observable<any> {
    return this.httpClient.get(url, { headers }).pipe(
      tap((res) => {}),
      catchError((e) => {
        this.processError(e);
        throw e;
      })
    );
  }

  post(url, params): Observable<any> {
    const headers = new HttpHeaders().set("Content-Type", "application/json");
    return this.httpClient
      .post(`${url}`, JSON.stringify(params), {
        headers,
      })
      .pipe(
        tap(async (res) => {}),
        catchError((e) => {
          this.processError(e);
          throw e;
        })
      );
  }

  put(url, params): Observable<any> {
    return this.httpClient.put(`${url}`, params).pipe(
      tap(async (res) => {}),
      catchError((e) => {
        this.processError(e);
        throw e;
      })
    );
  }
  patch(url, params): Observable<any> {
    return this.httpClient.patch(`${url}`, params).pipe(
      tap(async (res) => {}),
      catchError((e) => {
        this.processError(e);
        throw e;
      })
    );
  }
  postWithForm(url, params): Observable<any> {
    return this.httpClient.post(`${url}`, params).pipe(
      tap(async (res) => {}),
      catchError((e) => {
        this.processError(e);
        throw e;
      })
    );
  }

  processError(e) {
    if (e.status === 401) {
      //window.location.href = "/session-expired";
    }
  }
  checkHtmlInjection(text) {
    let result = true;
    this.tags.forEach((txt) => {
      let startTag = "<" + txt;
      let endTag = "</" + txt + ">";
      if (text.includes(startTag) || text.includes(endTag)) {
        result = false;
      }
    });
    return result;
  }
}
